module.exports = __webpack_public_path__ + "img/icons8-ferrari.ace9a2c6.svg";